import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiNotificationService} from "./api-notification.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiNotificationService]
})
export class ApiNotificationModule { }
